import { OnSiteStaffPage } from "@features/staff-on-site/components/OnSiteStaffPage";
import { requireRouteAudience } from "@services/router/routeAccess";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute('/_layout/staff/on-site')({
    component: OnSiteStaffPage,
    beforeLoad: requireRouteAudience(['staff']),
    staticData: {
        crumb: {
            label: "On-site staff list",
        }
    }
});
